/**
 * JHANGO ROCKS — Parallax Scroll-Over System v15
 * Simple: sticky sections with z-index stacking.
 * Header clearance: sections with [data-header-clearance] get
 * padding-top = header height so title never overlaps the logo.
 */
(function () {
  'use strict';

  var resizeT;
  var headerObserver = null;

  function measureHeader() {
    var hdr = document.querySelector('.hdr-jhango-rocks');
    if (!hdr) return 72;
    var h = hdr.getBoundingClientRect().height || hdr.offsetHeight;
    if (!h || h < 40) h = 72;
    return Math.round(h);
  }

  function setup() {
    var hw = document.querySelector('.header-section-jhango-rocks');
    if (hw) { hw.style.position = 'relative'; hw.style.zIndex = '9999'; }

    var hdrH = measureHeader();
    document.documentElement.style.setProperty('--jhango-hdr-h', hdrH + 'px');

    var sections = document.querySelectorAll('.parallax-stack-jhango-rocks');
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      s.style.zIndex = String(10 + i);

      if (s.querySelector('[data-no-sticky]')) {
        s.style.position = 'relative';
        s.style.top = 'auto';
      } else {
        s.style.position = 'sticky';
        s.style.top = '0';
        /* Promote each sticky section to its own compositor layer.
           iOS Safari handles this much smoother during momentum scroll —
           without it, sticky transitions can visibly jitter on fast scroll. */
        s.style.willChange = 'transform';
        s.style.transform = 'translateZ(0)';
        s.style.backfaceVisibility = 'hidden';
      }

      /* Header clearance: set padding-top on inner element = header height + gap.
         This ensures section title is ALWAYS below the fixed header. */
      var clearEl = s.querySelector('[data-header-clearance]');
      if (clearEl) {
        var padVal = hdrH + 20;
        clearEl.style.setProperty('padding-top', padVal + 'px', 'important');
      }

      /* Ensure section has a background color */
      var bg = window.getComputedStyle(s).backgroundColor;
      if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') {
        var child = s.firstElementChild;
        var cbg = child ? window.getComputedStyle(child).backgroundColor : '';
        if (!cbg || cbg === 'rgba(0, 0, 0, 0)' || cbg === 'transparent') {
          s.style.backgroundColor = '#ffffff';
        }
      }
    }

    attachHeaderObserver();
  }

  function attachHeaderObserver() {
    if (headerObserver || typeof ResizeObserver === 'undefined') return;
    var hdr = document.querySelector('.hdr-jhango-rocks');
    if (!hdr) return;
    headerObserver = new ResizeObserver(function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(setup, 120);
    });
    headerObserver.observe(hdr);
  }

  function scheduleSetup() {
    clearTimeout(resizeT);
    resizeT = setTimeout(setup, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else { setup(); }

  /* Re-run after full load so images/fonts that change header height are accounted for */
  window.addEventListener('load', scheduleSetup);

  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(setup, 150);
  });
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:reorder', setup);
})();

/**
 * =====================================================================
 * COLLECTION CARD VIDEOS — playback reliability
 *
 * Lives here rather than in sections/jhango-collection.liquid because that
 * section is 64 KB and has to be rewritten in full to change one line. This
 * file is already loaded sitewide from layout/theme.liquid, same arrangement
 * as the collection overrides in jhango-rocks-global.css.
 *
 * WHAT WAS WRONG
 * The section renders <video preload="none"> with the real URL parked in
 * <source data-src>. Its IntersectionObserver only assigns source.src once the
 * video is already 15% visible, and then calls play() on the very next line —
 * before a single byte has been fetched. That play() promise rejects, and the
 * section swallows it in an empty .catch() with no retry, so the video sits
 * there paused forever. Videos that did work were just winning a race.
 *
 * WHAT THIS DOES
 *  1. Starts the download ~600px before the video reaches the viewport, so the
 *     data is buffered by the time it is on screen.
 *  2. Listens for loadeddata/canplay and plays then, which is the point at
 *     which play() can actually succeed.
 *  3. Sweeps every 1.2s for any in-viewport video that is ready but paused —
 *     covers a rejected play() from an earlier autoplay block, tab switches,
 *     and iOS low-power mode.
 *
 * This only ever calls play(). Pausing off-screen videos is left to the
 * section's own observer, so the two never fight over the same element.
 * =====================================================================
 */
(function () {
  'use strict';

  var VIDEO_SELECTOR = '.js-coll-video-jr';
  var PRELOAD_MARGIN = 600; /* px ahead of the viewport to begin buffering */
  var SWEEP_MS = 1200;
  var sweepTimer = null;
  var preloadObserver = null;

  function viewportHeight() {
    return window.innerHeight || document.documentElement.clientHeight || 0;
  }

  function inViewport(el, margin) {
    var m = margin || 0;
    var r = el.getBoundingClientRect();
    if (!r.height && !r.width) return false;
    return r.bottom > -m && r.top < viewportHeight() + m;
  }

  function ensureSource(video) {
    var source = video.querySelector('source[data-src]');
    if (!source) return;
    if (source.getAttribute('src')) return;
    var url = source.getAttribute('data-src');
    if (!url) return;
    source.setAttribute('src', url);
    video.load();
  }

  function tryPlay(video) {
    if (!video.paused || video.ended) return;
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      /* Swallowed on purpose: the sweep below retries. */
      attempt.catch(function () {});
    }
  }

  function onReady(video) {
    return function () {
      if (inViewport(video, 0)) tryPlay(video);
    };
  }

  function prepare(video) {
    if (video.getAttribute('data-jr-video-ready')) return;
    video.setAttribute('data-jr-video-ready', '1');

    /* Autoplay is only permitted for muted inline video on mobile. The section
       sets these too, but a card appended by infinite scroll can reach us
       first, so they are re-asserted here rather than assumed. */
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('loop', '');

    /* Must happen before the src is assigned, or it has no effect. */
    if (video.getAttribute('preload') === 'none') {
      video.setAttribute('preload', 'metadata');
    }

    var ready = onReady(video);
    video.addEventListener('loadeddata', ready);
    video.addEventListener('canplay', ready);

    if (preloadObserver) {
      preloadObserver.observe(video);
    } else {
      ensureSource(video);
    }
  }

  function scan() {
    var videos = document.querySelectorAll(VIDEO_SELECTOR);
    if (!videos.length) return;
    for (var i = 0; i < videos.length; i++) prepare(videos[i]);
    startSweep();
  }

  function sweep() {
    if (document.hidden) return;
    var videos = document.querySelectorAll(VIDEO_SELECTOR);
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      if (!inViewport(v, 0)) continue;
      ensureSource(v);
      /* HAVE_CURRENT_DATA or better — anything less and play() would reject. */
      if (v.paused && v.readyState >= 2) tryPlay(v);
    }
  }

  function startSweep() {
    if (sweepTimer) return;
    sweepTimer = setInterval(sweep, SWEEP_MS);
  }

  if ('IntersectionObserver' in window) {
    preloadObserver = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) ensureSource(entries[i].target);
        }
      },
      { root: null, rootMargin: PRELOAD_MARGIN + 'px 0px', threshold: 0 }
    );
  }

  /* Infinite scroll appends cards straight into the grid, so watch for them. */
  function watchGrid() {
    var grid = document.getElementById('coll-grid-jr');
    if (!grid || grid.getAttribute('data-jr-video-watched')) return;
    if (typeof MutationObserver === 'undefined') return;
    grid.setAttribute('data-jr-video-watched', '1');
    new MutationObserver(function () { scan(); }).observe(grid, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    scan();
    watchGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sweep();
  });
})();

/**
 * =====================================================================
 * FOOTER — MOBILE ACCORDIONS
 *
 * Turns each footer block that has a heading (Quick Link, Help, Contact Us)
 * into a collapsible row on phones. The first one is open on load, the rest
 * are closed. The logo block has no heading, so it is skipped and always
 * shows.
 *
 * This script only marks up the DOM — all the hiding is done by the
 * max-width: 749px rules in jhango-rocks-global.css, which key off the
 * data-jr-facc attribute set here. Two consequences worth knowing:
 *
 *  - On desktop the attributes and the chevron are present but inert, because
 *    no CSS outside the mobile media query reads them. Nothing to undo on
 *    resize, and rotating a phone mid-session keeps whatever the visitor had
 *    open.
 *  - If this script never runs, no block is ever marked, so the CSS matches
 *    nothing and the footer stays fully expanded. It degrades to the old
 *    behaviour rather than to a footer that cannot be opened.
 *
 * Toggles are independent: opening Help does not close Quick Link. That is
 * how footers normally behave and it avoids the jump-to-top feel you get when
 * an open block collapses out from under a tap.
 * =====================================================================
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
  }

  function decorate(block, headingIndex) {
    if (block.getAttribute('data-jr-facc')) return;

    var heading = block.querySelector('.footer-block__heading');
    var content = block.querySelector('.footer-block__details-content');
    if (!heading || !content) return;

    var startOpen = headingIndex === 0;
    block.setAttribute('data-jr-facc', startOpen ? 'open' : 'closed');

    if (!heading.querySelector('.jr-facc-icon')) {
      var icon = document.createElement('span');
      icon.className = 'jr-facc-icon';
      icon.setAttribute('aria-hidden', 'true');
      heading.appendChild(icon);
    }

    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-expanded', startOpen ? 'true' : 'false');

    function toggle() {
      /* Desktop shows everything regardless, so a stray click there should not
         silently flip a state the visitor cannot see. */
      if (!isMobile()) return;
      var open = block.getAttribute('data-jr-facc') === 'open';
      block.setAttribute('data-jr-facc', open ? 'closed' : 'open');
      heading.setAttribute('aria-expanded', open ? 'false' : 'true');
    }

    heading.addEventListener('click', toggle);
    heading.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        toggle();
      }
    });
  }

  function init() {
    var wrapper = document.querySelector('.footer__blocks-wrapper');
    if (!wrapper) return;

    var blocks = wrapper.children;
    var headingIndex = 0;

    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (block.className.indexOf('footer-block') === -1) continue;
      if (!block.querySelector('.footer-block__heading')) continue;
      decorate(block, headingIndex);
      headingIndex++;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
